<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useToast } from 'primevue/usetoast';
import type { FileInfo } from '../types/File';
import { validateAndDownloadZip } from '../utils/files';
import { getAPIUrl } from '../utils/getApiUrl';
import { useOrderColor } from '../composables/useOrderColor';
import type { Order } from '../types/Order';
import { useUserStore } from '../stores/user';

const props = defineProps<{ info?: FileInfo, files?: FileInfo[], multiple?: boolean, class?: string, disableTooltip?: boolean, zipName?: string, order?: Order }>();
const { t } = useI18n();
const toast = useToast();
const { info, files, multiple, order } = toRefs(props);
const API_URL = getAPIUrl();

const { clrPrefix } = useOrderColor(order.value);

function downloadZip(files: FileInfo[], zipname: string | undefined) {
  validateAndDownloadZip({ files, zipname, skipDate: !!zipname, t, toast, clrPrefix: clrPrefix.value });
}

const userStore = useUserStore();

const name = computed(() => {
  if (userStore.profile.access_level === 'User') {
    return (info.value?.name ?? '').replace(`${userStore.profile.tag}-`, '');
  }
  return info.value?.name ?? '';
});
</script>

<template>
  <a
    v-if="!multiple && info?.status !== 'deleted'"
    v-tooltip.top="{ value: name ?? '', disabled: props.disableTooltip }"
    :href="`${API_URL}files/${info?.id}/download${clrPrefix ? `?color=${clrPrefix}` : ''}`"
    download
    class="block truncate text-[#1ea97c]"
    :class="props.class ?? ''"
  >
    <slot>
      {{ name }}
    </slot>
  </a>
  <span v-else-if="multiple && files" @click="downloadZip(files, props.zipName)">
    <slot />
  </span>
  <span
    v-else
    v-tooltip.top="`Изтрит файл: ${name}` ?? ''"
    class="block truncate"
    :class="props.class ?? ''"
  >
    <slot>
      {{ name }}
    </slot>
  </span>
</template>

<style scoped>

</style>
